import React from "react";
import { Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import * as Constants from "../../../../consts/Constants.js";
import Style from "../../../../styles/js/StyleCallList.js";
import Input from "./input";
import Results from "./results";
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Button from "@material-ui/core/Button";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import SendIcon from '@mui/icons-material/Send';
import LoadingButton from '@mui/lab/LoadingButton';
import CancelIcon from '@mui/icons-material/Cancel';
import ConfirmIcon from '@mui/icons-material/Done';

import { formatDateDDMMYYYYHHMM } from "../../../../plas/utils";
import service from '../../../../plas/services/calls/service';
import { applicationStates, applicationReplyCodes } from '../../../../plas/services/calls/models';
import alerter from '../../../alerts/alerter';

export default function Application( { applicationId } ) {

  const style = Style();

  const [application, setApplication] = React.useState(null);
  const [updating, setUpdating] = React.useState(false);
  const [askSend, setAskSend] = React.useState(false);

  const getApplication = () => {

    service.api.applications.get(applicationId,(response) => {
      if (response.result != null) {
        setApplication(response.result);
      } else {
        alerter.showError(response.error);
      }
    });
  }

  const sendApplication = () => {
    setUpdating(true);

    service.api.applications.sendApplication(application, (response) => {
      if (response.result != null) {
        application.lastUpdate = response.result.lastUpdate;
        application.state = response.result.state;
        setApplication(application);
        setAskSend(false);
        alerter.showSuccess("Postulación enviada correctamente.")
      } else {
        alerter.showError(response.error);
      }
      setUpdating(false);
    });
  }

  const getContent = (input) => {
    var inputContent = null;
    application.contents.forEach(content => {
      if (content.inputId === input.id) {
        inputContent = content
        return;
      }
    });
    return inputContent;
  } 

  React.useEffect(() => {
    getApplication();
  }, []);

  return (
    <div className={style.box} >
      { application != null ?
        (
          <div className={style.row }>
            <Card style={{ marginBottom: "15px"}}>
               <div className={style.itemHeader}>
                <Typography className={style.titleInitial}>
                  { application.call.name } 
                </Typography>
              </div>
              <div style={{ paddingLeft: "12px", paddingRight: "12px", textAlign:"left"}}>
                <div className={style.itemContent}>
                  <Stack style={{marginTop: "10px"}} direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
                    <Stack alignItems="start">
                        <Typography className={style.bodyInitial}>
                          <span style={{ color: Constants.COLOR_GRAY_DARK }}>Código de postulación: </span>
                          <span>#{application.callId}-{application.id}</span>
                        </Typography>
                        <Typography className={style.bodyInitial}>
                          <span style={{ color: Constants.COLOR_GRAY_DARK }}>Apertura de postulación: </span>
                          <span>{formatDateDDMMYYYYHHMM(application.creationTime)}</span>
                        </Typography>
                      </Stack>
                      <Stack alignItems="start">
                        <Typography className={style.bodyInitial} >
                          <span style={{ color: Constants.COLOR_GRAY_DARK }}>Estado: </span>
                          <span> { applicationStates[application.state] + " (" + formatDateDDMMYYYYHHMM(application.lastUpdate) + ")" }</span>
                        </Typography>
                        { application.state === 0 ?
                          (<Typography className={style.bodyInitial} >
                            <span style={{ color: Constants.COLOR_GRAY_DARK }}>Fecha limite de envío: </span>
                            <span> { application.extensionDate !== undefined ? 
                                formatDateDDMMYYYYHHMM(application.extensionDate) + " (prórroga)" :
                                formatDateDDMMYYYYHHMM(application.call.endDate) 
                              }
                            </span>
                          </Typography>) : null
                        }
                    </Stack>
                  </Stack>
                </div>
              </div>
            </Card>
            
            { application.call.result != null ? 
              (<Results application={application} />) : (null)
            }

            { application.replies.length > 0 ? (
              <Card style={{ marginBottom: "15px"}}>
                  <div className={style.itemHeader}>
                    <Typography className={style.titleInitial}>
                      Revisiones y comentarios
                    </Typography>    
                  </div>
                  <div style={{ padding: "12px", textAlign: "left"}}>
                    <Stack style={{marginTop: "10px"}} divider={<Divider orientation="horizontal" flexItem />} spacing={2}>      
                      { 
                        application.replies.map((reply) => (
                         <div>
                          <Typography className={style.bodyInitial} >
                            <span style={{fontWeight:"bold"}}>Fecha: </span>
                            <span>{formatDateDDMMYYYYHHMM(reply.creationTime)}</span>
                          </Typography>
                          <Typography className={style.bodyInitial} >
                            <span style={{fontWeight:"bold"}}>Estado de la postulación: </span>
                            <span>{applicationReplyCodes[reply.code]}</span>
                          </Typography>
                          { reply.extensionDate != null ? (
                            <div>
                              <span style={{fontWeight:"bold"}}>Fecha de prórroga: </span>
                              <span>{ formatDateDDMMYYYYHHMM(reply.extensionDate) }</span>                             
                            </div>
                            ) : (null)
                          }
                          <Typography style={{whiteSpace: "pre-line"}} className={style.bodyInitial} >
                            {reply.message}
                          </Typography>
                         </div>
                        ))
                      }
                    </Stack>
                  </div>
              </Card>) : null
            }

            { application.call.configuration.inputs.map((input) => (
                <Input application={application} inputData={ input } contentData={ getContent(input) } />
              ))
            }

            { application.canSend() ? (
              <div style={{marginBottom:"15px", textAlign:"right"}}>
                  <LoadingButton
                    style={{background: Constants.COLOR_PRIMARY, color: 'white' }}
                    loading={updating}
                    loadingPosition="start"
                    startIcon={<SendIcon />}
                    variant="contained"
                    onClick={ () => { setAskSend(true) }}>
                    <b>Enviar postulación</b>
                  </LoadingButton>
              </div>
              ) : null
            }
          </div>
        )
        :
        null
      }

      <Dialog
        open={askSend}
        onClose={ () => { if (!updating) setAskSend(false) }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle>
          ¿Enviar postulación?
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Su postulación sera enviada para su evaluación. Una vez enviada no podrá modificar los datos. En caso de que algun documento se encuentre mal subido o resulte ilegible, las autoridades podrán re-abrir su postulación para que corrija el error antes de reenviar.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
            style={{background: Constants.COLOR_GRAY, color: 'white' }}
            variant="contained"
            disabled={updating}
            startIcon={<CancelIcon />}
            onClick={ () => { setAskSend(false) } }>
            Cancelar
          </Button>
          <LoadingButton
            style={{background: Constants.COLOR_PRIMARY, color: 'white' }}
            loading={updating}
            loadingPosition="start"
            startIcon={<ConfirmIcon />}
            variant="contained"
            onClick={ () => { sendApplication() }}>
            <b>Confirmar</b>
          </LoadingButton>
        </DialogActions>
      </Dialog>

    </div>

  );
}
